import { IIndianState } from "../../Types";
import { CompanyGSTTypes, IndianStates } from "../../Types/CommonConstants";
import { ApiUtility } from "../../Utilities/ApiUtility.axios";
import { BusinessTypes, NewCompanyType } from "./ChartofAccountServicesNew";
import { BusinessNatures, DeducteeTypes } from "./ClientService";
import { ICostCentre } from "./CostCentersServices";
import { AssetStatus_New, FAAdjust_Type } from "./FixedAssetsServiceNew";
import { Languages } from "./GeneralSettingService";
import { IIdNameModel } from "./ItemsService";
import {
  IAddressDetails,
  IBankDetails,
  IContactInformation,
  IDueOn,
  IGstShort,
} from "./SettingService";
import { IFileNameModel, Party_Tax } from "./VoucherServices";
export interface ILedgerSearchByGroupNameResponse {
  id: string;
  companyId?: string;
  aliasName?: string;
  system: boolean;
  ledgerName: string;
  parent: string;
  groupName?: string;
  balance?: number;
  opBalAmount?: number;
  state?: IIndianState;
  partyOrTax?: Party_Tax;
  partyType?: PartyType;
  isBankLedger?: boolean;
  typeOfDuty?: Duty_Type;
  addresses?: IAddressDetails[];
  bankDetail?: IBankDetails[];
  contactInformation?: IContactInformation[];
  costCentres?: ICostCentre[];
  asstInvDetail?: IAsstInvDetail[];
  gstTaxType?: GSTTax_Type;
  gstType?: CompanyGSTTypes;
  gstRate?: IGstShort;
  gstin?: string;
  pan?: string;
  tdsDeductible?: boolean;
  tdsDeducteeType?: DeducteeTypes;
  existingTurnoverSal?: number;
  existingTurnoverPur?: number;
  deductTDSinSameVoucher?: boolean;
  ledgerTCSApplicability?: boolean;
  tcsCollecteeType?: DeducteeTypes;
  payTerms?: IDueOn;
  attachments?:IFileNameModel[];

}
export interface ILedgerAddResponse extends ILedgerSearchByGroupNameResponse {
  isEdited: boolean;
  underMSME?:boolean;
  tdsNature?:TDS_Nature;
  tcsNature?:TCS_Nature;
  tan?:string,
  status?:LedgerStatus,
  partyDisRate?:number,
  overseasState?:number,
  otherTaxRate?:number,
  order?:number,
  opBalDate?:string,
  opBalAmount?:number,
  msmeNo?:string,
  methodOfCalculation?:Duties_Calc_Methods,
  ledgerType?:NewCompanyType,
  ledgerTCSRate?:number 
  ledgerTCSNture?:string,
  language?:Languages
  isTransporter?:boolean,
  isDeleted?:boolean,
  isBankLedger?:boolean,
  isAudited?:boolean,
  isActive?:boolean,
  iec?:string,
  deleteUploadId?:string[],
  currency?:IIdNameModel,
  businessType?:BusinessTypes,
  businessNature?:BusinessNatures[];
  balance?:number,
}
export interface IAsstInvDetail {
  id: string;
  date: string;
  adjust: FAAdjust_Type;
  qty: number;
  returnedQty?: number;
  soldQty?: number;
  availableQty: number;
  price: number;
  accumulatedDepreciation?: number;
  assetRef?: IIdNameModel;
  status: AssetStatus_New;
  isDepreciatedCurrentYear?: boolean;
  assetDetail?: IAssetDetail[];
}
export interface IAssetDetail {
  id: string;
  name: string;
  number: string;
  status?: AssetStatus_New;
  assetLedger?: string;
  depreciationLedger?: string;
  accuDepreciationLedger?: string;
  isDepreciable?: boolean;
}
export enum MasterName {
  Group = "Group",
  Ledger = "Ledger",
}
export enum SearchLedgerByGroupsTypes {
  All,
  PartiesOnly,
  PartiesWithBank,
  BankAndCash,
  Sales,
  Purchase,
  DirectExpenses,
  IndirectExpenses,
  PaymentIn,
  PaymentOut,
  DutiesAndTaxes,
  DirectExpensesWithDutiesAndTaxes,
  IndirectExpensesWithDutiesAndTaxes,
  TaxforItems,
  IndirectIncomeOnly,
  FixedAssets,
  BankOnly,
  CashOnly,
  Depreciation,
  AssetnLiabilities,
  CreditorsOnly,
  DebtorsOnly,
  AllExpensesWithDutiesAndTaxes,
  TransporterOnly,
  FullAmountPayLedgers,
  FullAmountRecLedgers,
  SellingAndDistributionExpenses,
  AllExpenses,
  BillingAllGroups,
  AssetsOtherThanFixedAssets,
  LiabilitiesOtherThanCapital,
  CapitalOnly,
  Journal,
  AllExpensesnIncomes,
}

// Sundry creditors & Sundry debitors
export enum ImportLedgerAddType {
  Added,
  Exist,
  Denied,
}
export enum NewCompanyGstType_new {
  Unregistered,
  Regular,
  Composition,
  Unspecified,
  Consumer,
}
export enum TypeOfAddress {
  RegisteredAddress,
  BusinessAddress,
  BranchAddress,
  UnitAddress,
  GodownAddress,
}

// export enum AssetPurchase_Type {
//   All,
//   CurrentYear,
//   PreviousYear,
// }

// Dutes & Taxes enums
export enum Duty_Type {
  GST,
  TDS,
  TCS,
  Cess,
  Surcharge,
  Other,
}
export enum GSTTax_Type {
  IntegratedTax,
  CentralTax,
  StateTax,
  UnionTerritoryTax,
}
export enum TCS_Nature {
  Any,
}
export enum TDS_Nature {
  Any,
}
export enum Duties_Calc_Methods {
  TaxBasedOnItemRate,
  OnTotalSales,
  SurchargeOnTax,
  AdditionalDuty,
}
export enum LedgerStatus {
  all,
  active,
  deactive,
  deleted,
}

export const LedgerStatusDropDown = [
  { value: LedgerStatus.all, label: "All" },
  { value: LedgerStatus.active, label: "Active" },
  { value: LedgerStatus.deactive, label: "In-Active" },
];

export enum ClientStatus {
  Active,
  Inactive,
  Closed,
  All = 4,
}

export enum PartyType {
  IndividualPerson,
  CompanyFirm,
}

class LedgerService {
  route = `V1/API/Billing/Acc_New_Ledgers`;

  getResult(id: string, arg1: string, arg2: string, id1: any) {
    throw new Error("Method not implemented.");
  }
  // https: //localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/GetLedgersByGroupTypes?ledgersByGroupSelType=3
  getLedgersByGroupName = (
    companyId: any,
    ledgersByGroupSelType: SearchLedgerByGroupsTypes,
    search?: string
  ) =>
    ApiUtility.getResult<ILedgerSearchByGroupNameResponse[]>(
      `${this.route}/${companyId}/GetLedgersByGroupTypes`,
      {
        ledgersByGroupSelType,
        search,
      }
    );

  // "https://localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/GetList?start=0&length=15&groupSearch=a&ledgerParentId=661cfa1a60353ddd335781e3&status=1&GstTxt=G&StateTxt=0&ContPerson=a&ContPhone=a";
  //  ----- ladger Services(Api)  -----
  getLedgerList = (
    companyId: string | undefined,
    start?: number,
    length?: number,
    search?: string,
    groupSearch?: string,
    sortCol?: string,
    sortDir?: string,
    ledgerParentId?: string,
    status?: LedgerStatus,
    GstTxt?: string,
    StateTxt?: IndianStates,
    ContPerson?: string,
    Email?: string,
    ContPhone?: string,
    // filterSearch?: any
    // ledgerStatus: ledgerStatus
    OnlyViewValue?: boolean,
    ledgersByGroupSelType?: SearchLedgerByGroupsTypes
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetList`, {
      start,
      length,
      search,
      groupSearch,
      sortCol,
      sortDir,
      ledgerParentId,
      status,
      GstTxt,
      StateTxt,
      ContPerson,
      Email,
      ContPhone,
      OnlyViewValue,
      ledgersByGroupSelType,
      // ledgerStatus,
    });

  // https: //localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/65cdfde02b71e33b3f06f6ef
  getLedgerDetails = (companyId: string | undefined, ledgerId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/${ledgerId}`);

  // https://localhost:7142/v1/API/Acc_New_Ledgers/6463611020350584c0d5c017
  // https: //localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/65cdfde02b71e33b3f06f6ef

  postLedger = (companyId: string | undefined, params: any, id?: string) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}${id ? "/" + id : ""}`,
      params
    );

  // https://localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/MakeLedgerActiveDeactive/6603bb240221b834a09d1916
  // https: //localhost:7142/v1/API/Acc_New_Ledgers/65cdd05235241f48a55de738/MakeLedgerActiveDeactive/

  makeLedgerActiveInactive = (companyId: string, ledgerId: string) =>
    ApiUtility.post(
      `${this.route}/${companyId}/MakeLedgerActiveDeactive/${ledgerId}`,
      null
    );

  exportCsv = (
    companyId: string,
    search?: string,
    groupSearch?: string,
    sortCol?: string,
    sortDir?: string,
    ledgerParentId?: string,
    status?: LedgerStatus,
    GstTxt?: string,
    StateTxt?: IndianStates,
    ContPerson?: string,
    Email?: string,
    ContPhone?: string
    // filterSearch?: any
    // ledgerStatus: ledgerStatus
  ) =>
    ApiUtility.downloadFile(`${this.route}/${companyId}/Download/CSV`, {
      search,
      groupSearch,
      sortCol,
      sortDir,
      ledgerParentId,
      status,
      GstTxt,
      StateTxt,
      ContPerson,
      Email,
      ContPhone,
      // ledgerStatus,
    });

  deleteLedgerMaster = (companyId: string | undefined, ledgerId: string) =>
    ApiUtility.delete(`${this.route}/${companyId}/${ledgerId}`);

  ValidateImportLedgers = (companyId: string | undefined, csvData: any) =>
    ApiUtility.post(
      `${this.route}/${companyId}/ValidateImportLedgers`,
      csvData
    );

  ImportLedgers = (companyId: string | undefined, csvData: any) =>
    ApiUtility.post(`${this.route}/${companyId}/ImportLedgers`, csvData);

  // https://localhost:7142/v1/API/Acc_New_Ledgers/67a9a4ba0d34b9484de6443b/GetLedgerBalance/6603d2e2213d7a79139f42dc

  getLedgerBalance = (companyId: string, ledgerId: string) =>
    ApiUtility.get(`${this.route}/${companyId}/GetLedgerBalance/${ledgerId}`);
}

export default new LedgerService();
